<mat-expansion-panel
  [expanded]="panelOpenState"
  *ngIf="specifiche && specifiche.length > 0"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="pannello__title">
        {{ "base.info_aggiuntive" | translate }}
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <table class="mt-2">
    <tr *ngFor="let s of specificheFiltered">
      <td class="table__data__total table__data__30">
        {{ s.title | translate | titlecase }}
      </td>
      <td [innerHTML]="s.data" *ngIf="s.data && !s.traduci"></td>
      <td
        [innerHTML]="s.data | translate | titlecase"
        *ngIf="s.data && s.traduci"
      ></td>
    </tr>
  </table>
</mat-expansion-panel>
